import { render, staticRenderFns } from "./PdpComfortFeel.vue?vue&type=template&id=3654803c&scoped=true&"
import script from "./PdpComfortFeel.vue?vue&type=script&lang=js&"
export * from "./PdpComfortFeel.vue?vue&type=script&lang=js&"
import style0 from "./PdpComfortFeel.vue?vue&type=style&index=0&id=3654803c&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3654803c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PdpComfortScale: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/pdp/PdpComfortScale.vue').default})
